import { ApiService } from './../../services/api.service';
import { BaseDto } from './../../dto/BaseDto';
import { FlowService } from 'services/flow.service';
import { FlowConfig } from 'dto/FlowConfig';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'flow-picker',
  templateUrl: './flow-picker.component.html',
  styleUrls: ['./flow-picker.component.css']
})
export class FlowPickerComponent implements OnInit {
  @Input() actionDescriptionKey: string;
  @Input() selectedId = null;
  @Output() public onPick: EventEmitter<string> = new EventEmitter();
  flows: BaseDto[];
  loading: boolean = true;

  constructor(private router: Router, private apiService: ApiService) {
    this.flows = [];
  }

  ngOnInit() {
    this.apiService.getFlowNames().subscribe((result) => {
      this.flows = result;
      this.loading = false;
    });
   }

  onChange(): void {
    this.onPick.emit(this.selectedId);
  }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/flow-picker/flow-picker.component.ts